/**
 * SpinLoading 组件提供通用的 loading 展示
 * @module SpinLoading
 * @param {Number} [delay=200] 延迟展示时间
 * @param {String} src 替换默认的 loading 图片
 */

import { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { useTimeout } from 'ahooks';

import styles from './index.module.less';
 
const SpinLoading = ({ delay, src }) => {
  const [show, setShow] = useState(false);

  useTimeout(() => setShow(true), delay);

  if (!show) return null;
  
  return (
    <div className={ styles.spinLoading }>
      <img className={ styles.spinLoading__image } src={ src || require('@/images/loading.png') } />
    </div>
  );
};

SpinLoading.propTypes = {
  delay: PropTypes.number,
  src: PropTypes.string
};

SpinLoading.defaultProps = {
  delay: 200
};

export default memo(SpinLoading);
